import { render, staticRenderFns } from "./approved.vue?vue&type=template&id=8dd8035c&"
import script from "./approved.vue?vue&type=script&lang=js&"
export * from "./approved.vue?vue&type=script&lang=js&"
import style0 from "./approved.vue?vue&type=style&index=0&id=8dd8035c&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports